// extracted by mini-css-extract-plugin
export default {"field":"SellitemMoveStep_field__oDaNu","text":"SellitemMoveStep_text__tb3zq"};